var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"coocaa-plugin-loader",class:{ 'plugin-error': _vm.isError }},[(_vm.tipMsg)?_vm._t("tips",function(){return [_c('div',{staticClass:"plugin-tip"},[_vm._v(_vm._s(_vm.tipMsg))])]},{"tips":{
     content: _vm.tipMsg
   }}):_vm._e(),(!_vm.isError && _vm.pluginUrl)?_c('micro-app',{attrs:{"name":_vm.appName,"url":_vm.pluginUrl,"data":_vm.appData},on:{"datachange":_vm.handleDataChange,"mounted":_vm.handleMounted,"error":_vm.handleError}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }